import styled from 'styled-components';

export const InterestsWrapper = styled.div`
  margin-top: 32px;
  text-align: left;

  [dir='rtl'] & {
    margin-right: 0;
    text-align: right;
  }
`;

export const ExpandButton = styled('div')(({ isExpanded }) => ({
  padding: '1px',
  cursor: 'pointer',
  transform: isExpanded ? 'rotate(180deg)' : 'none',
}));

export const CheckboxGroupWrapper = styled('div')((props) => {
  const { isExpanded } = props;
  return {
    position: 'relative',
    overflow: 'hidden',
    height: isExpanded ? 'auto' : 0,
  };
});
